import { extendedProductRules, UserType } from '@webc/meeseeks-ui-sdk';

export const getGroupsTripsMessageAvailability = (
  departureCountryCode: string | undefined,
  arrivalCountryCode: string | undefined,
  userType: UserType,
) => {
  const countryId = `${departureCountryCode}-${arrivalCountryCode}`;
  const areGroupTripAvailable =
    extendedProductRules[countryId] &&
    extendedProductRules[countryId][userType]?.hasGroupTripsMessage;

  return !!areGroupTripAvailable;
};
